$('body').on('initScripts pageTransitionComplete', function() {
    const $body = $('body');

    $body.on('mouseenter focusin', '[data-toggle*="tooltip"]', function () {
        let $trigger = $(this),
            ttText = $(this).attr('title');

        if (typeof $(this).attr('aria-describedby') !== 'undefined' && $(this).attr('aria-describedby') !== "") {
            // tooltip already open
            return false;
        }

        if (typeof ttText !== 'undefined') {
            let ttClass = 'tooltip',
                ttPlacement = $(this).attr('data-placement');

            if (typeof ttPlacement !== 'undefined') {
                ttClass += ' tooltip--placement-' + ttPlacement;
            }

            let ttID = 'tooltip-' + randomInteger(10000, 99999),
                $tooltip = $('<div id="' + ttID + '" class="' + ttClass + '" role="tooltip"><div class="tooltip__arrow"></div><div class="tooltip__inner">' + ttText + '</div></div>');

            $body.append($tooltip);

            $tooltip.setTooltipPosition($trigger, ttPlacement);

            $trigger.attr('aria-describedby', ttID).attr('title', '').attr('data-original-title', ttText);

            $(this).on('mouseleave focusout', function () {
                $tooltip.remove();
                $trigger.attr('aria-describedby', '').attr('title', ttText).attr('data-original-title', '');
            });
        }
    });

    function randomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    $.fn.setTooltipPosition = function ($trigger = false, ttPlacement) {
        let $tooltip = $(this),
            $tooltipArrow = $('.tooltip__arrow', this),
            ttPosX,
            ttPosY;

        let liveViewportWidth = getViewportWidth();

        if (!$trigger) return false;

        if (typeof ttPlacement === 'undefined' || 'top' === ttPlacement) {
            ttPosX = $trigger.offset().left + $trigger.outerWidth() / 2 - $tooltip.outerWidth() / 2;
            ttPosY = $trigger.offset().top - $body.innerHeight();
        } else if ('right' === ttPlacement) {
            ttPosX = $trigger.offset().left + $trigger.outerWidth();
            ttPosY = $trigger.offset().top + $trigger.outerHeight() / 2 - $tooltip.outerHeight() / 2;
        } else if ('bottom' === ttPlacement) {
            ttPosX = $trigger.offset().left + $trigger.outerWidth() / 2 - $tooltip.outerWidth() / 2;
            ttPosY = $trigger.offset().top + $trigger.outerHeight();
        } else if ('left' === ttPlacement) {
            ttPosX = $trigger.offset().left - $body.innerWidth();
            ttPosY = $trigger.offset().top + $trigger.outerHeight() / 2 - $tooltip.outerHeight() / 2;
        }

        // set initial position
        $tooltip.css('transform', 'translate3d(' + ttPosX + 'px, ' + ttPosY + 'px, 0)');

        let diffX = 0,
            diffY = 0,
            ttaPosX = 0,
            ttaPosY = 0,
            bufferSize = 20;

        // move tooltip content if content exceeds window size
        if ($tooltip.offset().left < 0) {
            // console.log('tooltip exceeds window left');

            diffX = (-1 * $tooltip.offset().left) + bufferSize;
            ttPosX = ttPosX + diffX;
            ttaPosX = -1 * diffX;
        } else if ($tooltip.offset().left + $tooltip.outerWidth() > liveViewportWidth) {
            // console.log('tooltip exceeds window right');

            diffX = $tooltip.offset().left + $tooltip.outerWidth() - liveViewportWidth + bufferSize
            ttPosX = ttPosX - diffX;
            ttaPosX = diffX;
        } else if ($tooltip.offset().top < 0) {
            // console.log('tooltip exceeds window top');

            diffY = (-1 * $tooltip.offset().left) + bufferSize;
            ttPosY = ttPosY + diffY;
            ttaPosY = -1 * diffY;
        } else if ($tooltip.offset().top + $tooltip.outerHeight() > $(document).height()) {
            // console.log('tooltip exceeds window bottom');

            diffY = $tooltip.offset().top + $tooltip.outerHeight() - $(document).height() + bufferSize;
            ttPosY = ttPosY - diffY;
            ttaPosY = diffY;
        }

        // adjust position
        $tooltip.css('transform', 'translate3d(' + ttPosX + 'px, ' + ttPosY + 'px, 0)');
        $tooltipArrow.css('transform', 'translate3d(' + ttaPosX + 'px, ' + ttaPosY + 'px, 0)');
    }

    let viewportHeight = window.visualViewport.height,
        viewportWidth = window.visualViewport.width;

    // adjust open tooltip position on window resize
    window.visualViewport.addEventListener('resize', function () {
        if ($('.tooltip').length < 1) return false;

        let newViewportHeight = window.visualViewport.height,
            newViewportWidth = window.visualViewport.width;

        // before repositioning, check if document sizes have changed first
        if (newViewportHeight !== viewportHeight || newViewportWidth !== viewportWidth) {
            viewportHeight = newViewportHeight;
            viewportWidth = newViewportWidth;

            $('.tooltip').each(function () {
                let $tooltip = $(this),
                    $trigger = $('[aria-describedby="' + $tooltip.attr('id') + '"]'),
                    ttPlacement = $trigger.attr('data-placement');

                $tooltip.setTooltipPosition($trigger, ttPlacement);
            });
        }
    }, {passive: true});

    // adjust open tooltip position on scroll
    window.addEventListener('scroll', function () {
        if ($('.tooltip').length < 1) return false;

        $('.tooltip').each(function () {
            let $tooltip = $(this),
                $trigger = $('[aria-describedby="' + $tooltip.attr('id') + '"]'),
                ttPlacement = $trigger.attr('data-placement');

            $tooltip.setTooltipPosition($trigger, ttPlacement);
        });
    }, {passive: true});

    function getViewportWidth() {
        // Create temporary div for scrollbar width
        const $scrollDiv = $('<div/>')
            .css({
                width: '100px',
                height: '100px',
                overflow: 'scroll',
                position: 'absolute',
                top: '-9999px'
            })
            .appendTo('body');

        // Calculate scrollbar width
        const scrollbarWidth = $scrollDiv[0].offsetWidth - $scrollDiv[0].clientWidth;

        $scrollDiv.remove();

        // Reliable scrollbar detection
        const hasScrollbar = $(window).width() > $(document.documentElement).width();

        // Return viewport width, adjusted for scrollbar if present
        return hasScrollbar ? $(window).width() - scrollbarWidth : $(window).width();
    }
});
